var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"medicine-generic-badge",attrs:{"small":"","color":"#212B72"}},on),[_vm._v("fab fa-google")])]}}])},[_c('span',{staticClass:"inter text-bold",staticStyle:{"color":"#000"}},[_vm._v("Genérico")])])}
var staticRenderFns = []

export { render, staticRenderFns }